export const projects = [
    {
        topic: "Implementing Basic Search Nearby feature | Data Structures & Algorithms",
        guide: "Prof. Ashish Chiplunkar and Prof. Naveen Garg",
        link: "https://github.com/RishabhS21/col106_assignments",
        desc: [
            {
                point: "Finding nearby restaurants within a given Chebyshev distance of the searched restaurant.",
            },
            {
                point: "Preprocessed n points to a 2D Range Tree in O(nlog(n)), efficiently stores and retrieve (x,y) coordinates in an ordered way.",
            },
            {
                point: "Enabling users to find restaurants based on their location preferences in O(m + logn), m is number of query results.",
            }
        ]
    },
    {
        topic: "Simulating 1-Dimensional Collisions | Data Structures & Algorithms",
        guide: "Prof. Ashish Chiplunkar and Prof. Naveen Garg",
        link: "https://github.com/RishabhS21/col106_assignments",
        desc: [
            {
                point: "Simulated the collisions of n balls in one dimension by predicting the time, location and the balls which will collide.",
            },
            {
                point: "Implemented a customized Heap (a modified priority queue) with overall complexity for m collisions, O(n + mlog(n)).",
            },
        ]
    },
    {
        topic: "Pattern Searching Optimisation | Data Structures & Algorithms",
        guide: "Prof. Ashish Chiplunkar and Prof. Naveen Garg",
        link: "https://github.com/RishabhS21/col106_assignments",
        desc: [
            {
                point: "Optimised the search of a pattern in a text using extensive knowledge of hashing, tries",
            },
            {
                point: "Modified the KMP algorithm to optimise the space complexity and reduce the time taken",
            }
        ]
    },
    {
        topic: "Hardware Projects | Digital Logic & System Design",
        guide: "Prof. Preeti Ranjan Panda",
        link: "https://github.com/RishabhS21/col215_assignments",
        desc: [
            {
                point: "Made use of extensive knowledge of VHDL and Vivado in hardware and showed implementation on the FPGA board",
            },
            {
                point: "Made a stopwatch using logic and VHDL and showed It on the 7-segment display of the FPGA Board, made it on Xilinx Vivado",
            },
            {
                point: "Also made another project on memory blocks to make an 8x8 multiplier and made a 20bit register, add- accumulator",
            },
            {
                point: "Used memory files to take input from ROM and project output on RAM to make 128X128 multiplier",
            },
        ]
    },
    {
        topic: "Building a Basic Interpreter for Python Program | Basic Programming",
        guide: "Prof. Preeti Ranjan Panda and Prof. Sanjeeva Prasad",
        link: "https://github.com/RishabhS21/col100_assignments/tree/main/a5",
        desc: [
            {
                point: "Prepared the model entirely from the scratch using only Python for reading and storing basic commands from text, VARIABLE = EXPRESSION",
            },
            {
                point: "Read the input file, one statement at a time and interpret the statement by maintaining all variables and values in datalist.",
            },
            {
                point: "Program help storead, For example: x=2+1, y=x/3, x=7 etc. simultaneously.",
            },
            {
                point: "maintained a Garbage Collection for the stored items when not referred by any variable.",
            }
        ]
    },
    {
        topic: "Sudoku Solver | Basic Programming",
        guide: "Self Project",
        link: "https://github.com/RishabhS21/col100_assignments/tree/main/sudoku%20solver",
        desc: [
            {
                point: "Built an efficient program in Python that solves sudoku using recursion and backtracking.",
            },
        ]
    },
    {
        topic: "Prolog Interpreter in Ocaml | Programming Languages",
        guide: "Prof. Sanjeeva Prasad",
        link: "https://github.com/RishabhS21/COL226-Assignments",
        desc: [
            {
                point: "Developed an interpreter for a simplified logic programming language akin to Prolog, utilizing OCaml, Lex, and Yacc.",
            },
            {
                point: "Designed concrete grammatical specifications based on abstract syntax definitions, introducing custom syntax enhancements, showcasing skills in language design, compiler construction, and functional programming.",
            },
        ]
    },
    {
        topic: "Copy-on-Write (COW) Mechanism in xv6 Operating System | Operating Systems",
        guide: "Prof. Abhilash Jindal",
        link: "https://github.com/RishabhS21/COL331-Assignments",
        desc: [
            {
                point: "Enhanced memory utilization during fork() by deferring physical allocation until necessary.",
            },
            {
                point: "Enabled memory sharing and handled writes on shared pages, reducing redundant memory allocations.",
            },
            {
                point: "Integrated COW with swapping, introducing rmap data structure for managing process mappings and swap space."
            }
        ]
    },
    {
        topic: "Medical Diagnosis | Bayesian Learning | Artificial Intelligence",
        guide: "Prof. Mausam",
        link: "https://github.com/RishabhS21/COL333-Assignments/blob/main/A4",
        desc: [
            {
                point: "Designed and implemented a distributed algorithm for P2P file-sharing, enabling decentralized sharing and downloading."
            },
            {
                point: "Developed a client-server network for simultaneous client connections, optimizing efficient line transmission with restrictions."
            },

        ]
    },
    {
        topic: "Distributed P2P File Sharing System | Socket Programming | Computer Networks",
        guide: "Prof. Adhiteshwar Seth",
        link: "https://github.com/RishabhS21/COL334-Assignments/blob/main/A2",
        desc: [
            {
                point: "Developed a Bayesian Network processing engine to analyze and learn parameters from healthcare datasets."
            },
            {
                point: "Implemented probabilistic inference methods for missing data in medical records, enabling accurate diagnosis."
            },
            {
                point: "Conducted tests, noting non-linear download time reduction with increased client collaboration, managing exceptions."
            },
        ]
    },
    {
        topic: "Reliable File Transfer with Congestion Control | UDP | Computer Networks",
        guide: "Prof. Adhiteshwar Seth",
        link: "https://github.com/RishabhS21/COL334-Assignments/blob/main/A3",
        desc: [
            {
                point: "Implemented a custom UDP-based file transfer client, enabling reliable data transfer and real-world network simulation."
            },
            {
                point: "Established reliable communication with the server, mitigated packet loss, and designed timeout mechanisms."
            },
            {
                point: "Managed congestion control using adaptive timeout intervals and the AIMD strategy."
            },
        ]
    },
    {
        topic: "Graph Clique Identification | SAT Solving | Artificial Intelligence",
        guide: "Prof. Mausam",
        link: "https://github.com/RishabhS21/COL333-Assignments/blob/main/A4",
        desc: [
            {
                point: "Executed a complex computational task, the identification of k-size cliques within a graph, a renowned NP-hard challenge."
            },
            {
                point: "Utilized SAT-solving methodology via MiniSat, transforming the problem into a CNF formula by generating clauses."
            },
        ]
    },
    {
        topic: "Sports Complex Planning | Local Search | Artificial Intelligence",
        guide: "Prof. Mausam",
        link: "https://github.com/RishabhS21/COL333-Assignments/blob/main/A1",
        desc: [
            {
                point: "Implemented the Greedy Hill Climbing with Random Restart algorithm to optimize sports zone allocation in a large sports complex, reducing walking times for users. This collaborative effort involved heuristic search and algorithm evaluation for enhanced optimization."
            },
        ]
    },
    {
        topic: "Advanced Adversarial Search with Alpha-Beta Pruning for Rollerball | Artificial Intelligence",
        guide: "Prof. Mausam",
        link: "https://github.com/RishabhS21/COL333-Assignments/blob/main/A5",
        desc: [
            {
                point: "Implemented advanced adversarial search algorithms, including minimax and α-β pruning, for the board game Rollerball."
            },
            {
                point: "Developed custom strategies for searching and calculating moves up to a specified depth level, enhancing AI performance."
            },
            {
                point: "Fine-tuned the AI to compete against various opponents, demonstrating strong problem-solving skills."
            },
        ]
    },
    {
        topic: "2 Levels Cache Simulator | Computer Architecture",
        guide: "Prof. Rijurekha Sen",
        link: "https://github.com/RishabhS21/COL216-Assignments/blob/main/Assignment3",
        desc: [
            {
                point: "Developed C++ simulator code for n-way set associative cache with 2 levels, using LRU and WBWA policies."
            },
            {
                point: "Implemented counters to track cache reads, misses, writes, and write-backs; printed cache stats at simulation end."
            },
        ]
    },
    {
        topic: "5-Stage MIPS Pipeline and Branch Predictor | Computer Architecture",
        guide: "Prof. Rijurekha Sen",
        link: "https://github.com/RishabhS21/COL216-Assignments/blob/main/Assignment2",
        desc: [
            {
                point: "Implemented a basic 5-stage MIPS pipeline in C++ with register-based data structure and ALU operations."
            },
            {
                point: "Enhanced the pipeline by implementing bypassing to forward input to EX/MEM stages, improving cycle efficiency."
            },
            {
                point: "Incorporated a branch predictor with 2-bit saturating counters and BHRs to optimise control hazard prediction."
            },
        ]
    },
]